module.exports = __webpack_public_path__ + "static/media/recap-background-image.288b2654.webp";